var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Suspense } from "react";

var NotFound = function (_React$Component) {
    _inherits(NotFound, _React$Component);

    function NotFound(props) {
        _classCallCheck(this, NotFound);

        var _this = _possibleConstructorReturn(this, (NotFound.__proto__ || Object.getPrototypeOf(NotFound)).call(this, props));

        _this.state = {
            hasError: false
        };
        return _this;
    }

    _createClass(NotFound, [{
        key: "componentDidCatch",
        value: function componentDidCatch(error, errorInfo) {}
    }, {
        key: "render",
        value: function render() {
            if (this.state.hasError) {
                var Ele = null,
                    to = this.props.route && this.props.route.pathname || '';

                if (this.props.notfound) {
                    Ele = this.props.notfound;
                }

                return Ele ? React.createElement(
                    Suspense,
                    { fallback: this.props.suspenseFallback || React.createElement(
                            "span",
                            null,
                            "Loading....."
                        ) },
                    React.createElement(Ele, { url: to })
                ) : React.createElement(
                    "div",
                    null,
                    React.createElement(
                        "h3",
                        null,
                        "Not Found"
                    ),
                    React.createElement(
                        "div",
                        null,
                        to
                    )
                );
            }
            return this.props.children;
        }
    }], [{
        key: "getDerivedStateFromError",
        value: function getDerivedStateFromError() {
            return { hasError: true };
        }
    }]);

    return NotFound;
}(React.Component);

export default NotFound;